import React, { PropsWithChildren } from 'react'
import { ComponentProps } from 'react'

import { bemJoin, classNames } from '@app/lib/bem'
import { MergeProps } from '@app/lib/types'

import './IconBadge.scss'

export type IconBadgeProps = MergeProps<
  ComponentProps<'div'>,
  {
    color?: 'neutral' | 'success' | 'danger' | 'info' | 'secondary'
    size?: 'md' | 'sm' | 'smd'
  }
>

const b = bemJoin('icon-badge')

export const IconBadge = ({
  color = 'neutral',
  size = 'md',
  className,
  children,
  ...rest
}: PropsWithChildren<IconBadgeProps>) => {
  return (
    <div
      {...rest}
      className={classNames(
        b({
          [color]: true,
          [size]: true
        }),
        className
      )}
    >
      {children}
    </div>
  )
}
